import { render, staticRenderFns } from "./ItemAdditions.vue?vue&type=template&id=2ad85d54&scoped=true&"
import script from "./ItemAdditions.vue?vue&type=script&lang=js&"
export * from "./ItemAdditions.vue?vue&type=script&lang=js&"
import style0 from "./ItemAdditions.vue?vue&type=style&index=0&id=2ad85d54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad85d54",
  null
  
)

export default component.exports